export default __webpack_public_path__ + "assets/power_user_badge-d87c30c9d28b61f1bfee9ea9345830be.png";